import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { SuperAdminService } from '../services/super-admin.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Portal do administrador geral: token próprio, e o 401 leva ao login do portal
  const superAdmin = inject(SuperAdminService);
  if (req.url.startsWith(superAdmin.apiUrl)) {
    const superToken = superAdmin.getToken();
    const request = superToken ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${superToken}`) }) : req;
    return next(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && !req.url.endsWith('/login')) {
          superAdmin.logout();
          router.navigate(['/super-admin', 'login']);
        }
        return throwError(() => err);
      })
    );
  }
  // Sessão da loja (ou do painel) em que o usuário está
  const token = authService.getToken();

  // O token só acompanha as chamadas à nossa API
  if (!token || !req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  const clonedReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`)
  });

  return next(clonedReq).pipe(
    catchError((err: HttpErrorResponse) => {
      // Token expirado/inválido: encerra a sessão e pede novo login (o da loja atual ou o do painel)
      if (err.status === 401) {
        const slug = authService.storeSlug();
        authService.logout();
        localStorage.setItem('redirect_after_login', router.url);
        router.navigate(slug ? ['/', slug, 'login'] : ['/entrar']);
      }
      // 402 = trial/assinatura da empresa vencidos: o administrador vai para a tela de assinatura
      if (err.status === 402 && !authService.storeSlug()) {
        router.navigate(['/admin', 'subscription']);
      }
      return throwError(() => err);
    })
  );
};
